import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import './driving-license.css';
import * as AuthService from '../../services/auth';

const Card = ({item}: any) => (
  <div className="card-scale-wrapper">
    <div className="card-container">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          marginBottom: '1cm',
          pageBreakInside: 'avoid'
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '20cm',
            height: '6cm'
          }}
        >
          {/* Front side */}
          <div
            style={{
              width: '10cm',
              height: '6.5cm',
              border: '1px solid black',
              padding: '0.2cm',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              borderRight: 'none',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div style={{display: 'flex', flexGrow: 1}}>
              {/* Image section */}
              <div
                style={{
                  flex: '0 0 40%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <img
                  src="/img/image.png"
                  alt="logo"
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '1cm',
                    objectFit: 'cover',
                    marginBottom: '7.5px'
                  }}
                />
                <div
                  style={{
                    width: '150px',
                    height: '150px',
                    overflow: 'hidden',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <img
                    src={`https://itservice.advanceagro.net/EmployeeCard/empimages/${item.EMP_ID}.jpg`}
                    alt="image"
                    style={{
                      width: '100%',
                      height: '100%',
                      border: '1px solid black',
                      padding: '3px',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = `https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=${item.EMP_ID}&Size=128`;
                    }}
                  />
                </div>
              </div>

              {/* Info section */}
              <div
                style={{
                  flex: '1 1 auto',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  wordBreak: 'break-word',
                  paddingLeft: '0.3cm',
                  position: 'relative'
                }}
              >
                <div style={{marginBottom: '0.3em'}}>
                  <strong>
                    บัตรอนุญาตขับขี่
                    <br />
                    รถฟอร์คลิฟท์และรถคีบม้วน
                  </strong>
                </div>
                <div
                  style={{
                    fontSize: '0.7em',
                    color: '#666',
                    fontWeight: 550,
                    marginBottom: '0.5rem'
                  }}
                >
                  FORKLIFT & Roll Clamp LICENSE
                </div>
                {item?.DRIVER_NO && (
                  <div style={{marginBottom: '0.3em', fontSize: '0.9em'}}>
                    <span style={{fontWeight: 'bold'}}>
                      เลขที่ {item.DRIVER_NO}
                    </span>{' '}
                    <br />
                  </div>
                )}
                <div style={{marginBottom: '0.5em', fontSize: '0.9em'}}>
                  <span style={{color: '#1004b6ff'}}>{item.EMPNAME}</span>{' '}
                  <br />
                  <span>หน่วยงาน: </span>
                  <span
                    style={{
                      color: '#1004b6ff',
                      wordBreak: 'break-word',
                      fontSize: item.DEPARTMENT?.length > 40 ? '10px' : '13px',
                      lineHeight: '1.2em'
                    }}
                  >
                    {item.DEPARTMENT}
                  </span>
                </div>

                {/* ลงชื่อผู้อนุญาต - อยู่ล่างสุดเสมอ */}
                <div
                  style={{
                    fontSize: '0.9em',
                    position: 'absolute',
                    bottom: '0',
                    left: '0.3cm',
                    right: '0'
                  }}
                >
                  <span>
                    ลงชื่อผู้อนุญาต{' '}
                    {item?.SIGNED && (
                      <img
                        src={item.SIGNED}
                        alt="signature"
                        style={{
                          height: '25px',
                          width: 'auto',
                          objectFit: 'contain',
                          verticalAlign: 'middle',
                          marginLeft: '8px'
                        }}
                      />
                    )}
                  </span>
                  <br />
                  <span>( {item?.TRAINER_NAME || ''} )</span>
                </div>
              </div>
            </div>

            {/* Date row */}
            <div
              style={{
                fontSize: '0.75em',
                marginTop: '0.1cm',
                textAlign: 'left'
              }}
            >
              <span style={{color: 'green', marginRight: '10px'}}>
                วันออกบัตร: {item.TRAINING_DATE || '-'}
              </span>
              <span style={{color: 'red'}}>
                วันหมดอายุ: {item.TRAINING_EXPIRE_DATE || '-'}
              </span>
            </div>
            <div
              style={{
                fontSize: '0.75em',
                marginTop: '0.1cm',
                textAlign: 'left'
              }}
            >
              <span style={{marginRight: '10px'}}>
                Double A (1991) Public Company Limited.
              </span>
            </div>
          </div>
          {/* Back side */}
          <div
            style={{
              width: '10cm',
              height: '6.5cm',
              border: '1px solid black',
              padding: '0.4cm',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              fontSize: '0.85em'
            }}
          >
            <ul style={{paddingLeft: '1em', margin: 0}}>
              <li>
                ติดบัตรทุกครั้งเมื่อขับรถฟอร์คลิฟท์ (FolkLift) และรถคีบม้วน
                (Roll Clamp)
              </li>
              <li>
                ต้องต่ออายุบัตรก่อนถึงวันหมดอายุ
                โดยผู้ขับขี่ต้องได้รับการอบรมจากผู้ชำนาญการเท่านั้น
              </li>
              <li>
                ต้องปฏิบัติตามกฎระเบียบการขับรถฟอร์คลิฟท์ (Folklift)
                และรถคีบม้วน (Roll Clamp) อย่างเคร่งครัด หากผู้ใดฝ่าฝืน
                หรือกระทำความผิดจะถูกลงโทษ
              </li>
            </ul>
            <p style={{marginTop: '1em', textAlign: 'center'}}>
              <strong style={{fontSize: '13.5px'}}>
                บริษัท ดั๊บเบิ้ลเอ (1991) จำกัด (มหาชน)
                <br />1 หมู่ 2 ต.ท่าตูม อ.ศรีมหาโพธิ จ.ปราจีนบุรี 25140
              </strong>
            </p>
            <p
              style={{
                marginTop: '1.6em',
                fontSize: '15px',
                textAlign: 'center'
              }}
            >
              ฝ่ายความปลอดภัยโทร{' '}
              <strong style={{fontSize: '13.5px'}}>085-835-4738</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const CardNPS = ({item}: any) => (
  <div className="card-scale-wrapper">
    <div className="card-container">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          // marginBottom: '1cm',
          pageBreakInside: 'avoid'
        }}
      >
        <div
          style={{
            display: 'flex',
            width: '20cm',
            height: '6cm'
          }}
        >
          {/* Front side */}
          <div
            style={{
              width: '10cm',
              height: '6.5cm',
              border: '1px solid black',
              padding: '0.2cm',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              borderRight: 'none',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div style={{display: 'flex', flexGrow: 1}}>
              {/* Image section */}
              <div
                style={{
                  flex: '0 0 40%',
                  display: 'flex',
                  flexDirection: 'column'
                  // alignItems: 'center'
                }}
              >
                <img
                  src="https://www.npsplc.com/themes/default/assets/static/images/logo/logo.png"
                  alt="logo"
                  style={{
                    width: '40%',
                    height: 'auto',
                    maxHeight: '1cm',
                    objectFit: 'cover',
                    margin: '0 0 7.5px 0',
                    display: 'block'
                  }}
                />
                <div
                  style={{
                    width: '150px',
                    height: '150px',
                    overflow: 'hidden',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}
                >
                  <img
                    src={`https://itservice.advanceagro.net/EmployeeCard/empimages/${item.EMP_ID}.jpg`}
                    alt="image"
                    style={{
                      width: '100%',
                      height: '100%',
                      border: '1px solid black',
                      padding: '3px',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = `https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=${item.EMP_ID}&Size=128`;
                    }}
                  />
                </div>
              </div>

              {/* Info section */}
              <div
                style={{
                  flex: '1 1 auto',
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  wordBreak: 'break-word',
                  paddingLeft: '0.3cm',
                  position: 'relative'
                }}
              >
                <div style={{marginBottom: '0.3em'}}>
                  <strong>
                    บัตรอนุญาต
                    <br />
                    ขับรถฟอร์คลิฟท์ และรถคีบม้วน
                  </strong>
                </div>
                <div
                  style={{
                    fontSize: '0.7em',
                    color: '#666',
                    fontWeight: 550,
                    marginBottom: '0.5rem'
                  }}
                >
                  FORKLIFT & Roll Clamp LICENSE
                </div>
                {item?.DRIVER_NO && (
                  <div style={{marginBottom: '0.3em', fontSize: '0.8em'}}>
                    <span style={{fontWeight: 'bold'}}>
                      เลขที่ {item.DRIVER_NO}
                    </span>{' '}
                    <br />
                  </div>
                )}
                <div style={{marginBottom: '0.5em', fontSize: '0.9em'}}>
                  <span style={{color: '#1004b6ff', fontWeight: 'bold'}}>
                    {item.EMPNAME}
                  </span>{' '}
                  <br />
                  <span>สายงาน: </span>
                  <span
                    style={{
                      color: '#1004b6ff',
                      wordBreak: 'break-word',
                      fontSize: item.LINEOFWORK?.length > 40 ? '10px' : '13px',
                      lineHeight: '1.2em'
                    }}
                  >
                    {item.LINEOFWORK}
                  </span>
                </div>

                {/* ลงชื่อผู้อนุญาต - อยู่ล่างสุดเสมอ */}
                <div
                  style={{
                    fontSize: '0.9em',
                    position: 'absolute',
                    bottom: '0',
                    left: '0.3cm',
                    right: '0'
                  }}
                >
                  <span>
                    ลงชื่อผู้อนุญาต{' '}
                    {item?.SIGNED && (
                      <img
                        src={item.SIGNED}
                        alt="signature"
                        style={{
                          height: '25px',
                          width: 'auto',
                          objectFit: 'contain',
                          verticalAlign: 'middle',
                          marginLeft: '8px'
                        }}
                      />
                    )}
                  </span>
                  <br />
                  <span>( {item?.TRAINER_NAME || ''} )</span>
                </div>
              </div>
            </div>

            {/* Date row */}
            <div
              style={{
                fontSize: '0.75em',
                marginTop: '0.1cm',
                textAlign: 'left'
              }}
            >
              <span style={{color: 'green', marginRight: '10px'}}>
                วันออกบัตร: {item.TRAINING_DATE || '-'}
              </span>
              <span style={{color: 'red'}}>
                วันหมดอายุ: {item.TRAINING_EXPIRE_DATE || '-'}
              </span>
            </div>
            <div
              style={{
                fontSize: '0.75em',
                marginTop: '0.1cm',
                textAlign: 'center'
              }}
            >
              <span style={{marginRight: '10px', textAlign: 'center'}}>
                National Power Supply Company Limited
              </span>
            </div>
          </div>

          {/* Back side */}
          <div
            style={{
              width: '10cm',
              height: '6.5cm',
              border: '1px solid black',
              padding: '0.4cm',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              fontSize: '0.85em'
            }}
          >
            <ul style={{paddingLeft: '1em', margin: 0}}>
              <li>
                ติดบัตรทุกครั้งเมื่อขับรถฟอร์คลิฟท์ (FolkLift) และรถคีบม้วน
                (Roll Clamp)
              </li>
              <li>
                ต้องต่ออายุบัตรก่อนถึงวันหมดอายุ
                โดยผู้ขับขี่ต้องได้รับการอบรมจากผู้ชำนาญการเท่านั้น
              </li>
              <li>
                ต้องปฏิบัติตามกฎระเบียบการขับรถฟอร์คลิฟท์ (Folklift)
                และรถคีบม้วน (Roll Clamp) อย่างเคร่งครัด หากผู้ใดฝ่าฝืน
                หรือกระทำความผิดจะถูกลงโทษ
              </li>
            </ul>
            <p style={{marginTop: '1em', textAlign: 'center'}}>
              <strong style={{fontSize: '13.5px', color: '#1004b6ff'}}>
                บริษัท เนชั่นแนล เพาเวอร์ ซัพพลาย จำกัด (มหาชน)
                <br />
                206 หมู่ 4 ต.ท่าตูม อ.ศรีมหาโพธิ จ.ปราจีนบุรี 25140
              </strong>
            </p>
            <p
              style={{
                marginTop: '1.6em',
                fontSize: '15px',
                textAlign: 'center'
              }}
            >
              ฝ่ายความปลอดภัย ติดต่อ{' '}
              <strong style={{fontSize: '13.5px'}}>{item.SAFETY_ID}</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const DrivingLicense = () => {
  const {empid} = useParams();

  const [data, setData] = useState({});
  const [mode, setMode] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (empid) {
          const _result = await AuthService.downloadDrivingLicense(empid);

          const _data = _result[0];
          const _mode = !_data?.SAFETY_ID ? 'AA' : 'NPS';

          setMode(_mode);
          setData(_data);
        }
      } catch (error) {
        console.error('Error fetching driving license:', error);
      }
    };

    fetchData();
  }, [empid]);

  return (
    <div className="content">
      <div
        className="print-container d-flex flex-column align-items-center"
        style={{
          minHeight: '100vh',
          overflowX: 'auto',
          overflowY: 'visible',
          padding: '1cm 0'
        }}
      >
        {data ? (
          mode === 'AA' ? (
            <Card item={data} />
          ) : (
            <CardNPS item={data} />
          )
        ) : (
          <div
            style={{
              fontSize: '1.1em',
              color: '#777',
              marginTop: '2rem'
            }}
          >
            ยังไม่พบข้อมูลผู้ที่ผ่านการอบรม Folklift & Roll Clamp
          </div>
        )}
      </div>
    </div>
  );
};

export default DrivingLicense;
